import dynamic from "next/dynamic";

export const dynamicComponents = (componentIds: string[]) => {
  const result: any = {};
  componentIds.map((id) => {
    const Widget = dynamic(() => import(`../`).then((mod: any) => mod[id]), {
      ssr: true,
    });
    result[id] = Widget;
  });
  return result;
};
